// "use server";

import fetcher from "@/lib/fetcher";
import { actionClient } from "@/lib/safe-action";
import { objToCamelCase } from "@/lib/utils";
import handleErrorResponse from "@/lib/handle-error-response";

export const fetchContinuePreparationList = actionClient.action(async () => {
  const response = await fetcher(
    "/api/app-consumption-ws/api/v1/video/videos/testseries/status",
    { params: { source: "web" } }
  );

  if (!response.ok) return handleErrorResponse(response);

  const data = await response.json();
  if (data.success) return objToCamelCase(data.data);

  return null;
});
